import { render, staticRenderFns } from "./BasCurrencyModal.vue?vue&type=template&id=a4bf624e&scoped=true&"
import script from "./BasCurrencyModal.vue?vue&type=script&lang=js&"
export * from "./BasCurrencyModal.vue?vue&type=script&lang=js&"
import style0 from "./BasCurrencyModal.vue?vue&type=style&index=0&id=a4bf624e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bf624e",
  null
  
)

export default component.exports